import React from 'react';
import "./edutile.css";

const EduTile = ({ icon, title, description, image }) => {
  return (
    <div className="building-process">
      <div className="building-process__container">
        {/* Logo/Icon 
        <div className="building-process__logo">
          <img
            src={icon}
            alt="Tile Icon"
            width="96"
            height="96"
            className="building-process__logo-image"
          />
        </div>

        */}

        {/* Title */}
        <h1 className="building-process__title">{title}</h1>

        {/* Subtitle */}
        <p className="building-process__subtitle">{description}</p>

        {/* Illustration */}
        <div className="building-process__illustration">
          <img
            src={image}
            alt="Tile Illustration"
            width="192"
            height="192"
            className="building-process__illustration-image"
          />
        </div>
      </div>
    </div>
  );
}

export default EduTile;